<template lang="pug">
  .d-flex
    v-select(
      v-model="selectedTimezone"
      label="Часовой пояс"
      :items="timezones"
      :loading="loading.timezones"
      item-text="title"
      return-object
      rounded
      filled
    )
    v-btn(
      v-if="selectedTimezone"
      color="success"
      :loading="loading.btn"
      depressed
      rounded
      x-large
      @click="saveTimezone"
    ).ml-5
      span {{ success ? 'Успешно' : 'Изменить' }}
      v-icon.ml-1(v-if="success") mdi-check-circle
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      selectedTimezone: this.$user.data.settings.time_zone,
      timezones: [],
      loading: {
        btn: false,
        timezones: true,
      },
      success: false,
    };
  },
  created() {
    this.getTimezoneList();
  },
  methods: {
    ...mapActions({ CHANGE_TIMEZONE: 'auth/CHANGE_TIMEZONE' }),
    async saveTimezone() {
      this.loading.btn = true;
      await this.CHANGE_TIMEZONE(this.selectedTimezone);
      this.loading.btn = false;
      this.success = true;
    },
    async getTimezoneList() {
      this.loading.timezones = true;
      await this.$rHandler(
        this.$api.system.getTimezoneList(),
        (r) => {
          this.timezones = r.data.data;
        },
      );
      this.loading.timezones = false;
    },
  },
};
</script>
